import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import messages from 'aurora-translations';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import history from 'aurora-utils/history';
import ADGMImage from '../ADGMImage';
import styles from './styles';

function EmptyAplication2(props) {
  const { classes } = props;
  const clickHandler = () => {
    history.push('/app/services');
  };
  return (
    <div className={classes.transactionsNotification}>
      <figure>
        <ADGMImage name='notificationFileIcon.svg' alt='Notification img' />
      </figure>
      <div className={classes.tcTextHolder}>
        <Typography variant='body1' component='h1' className={classes.title}>
          <FormattedMessage {...messages.you_dont_have_tasks_yet} />
        </Typography>
        <Typography variant='body1'>
          <FormattedMessage {...messages.this_is_where_tasks_will_appear} />
        </Typography>
        <Button variant='contained' className={classes.btnADGMred} onClick={clickHandler}>
          <FormattedMessage {...messages.start_a_service_now} />
        </Button>
      </div>
    </div>
  );
}

EmptyAplication2.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(EmptyAplication2);
